import Vue from "vue";
import Vant from "vant"; //,{Locale}
import "vant/lib/index.css";

Vue.use(Vant);
